/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import type { YextHolidayHour } from '../interface/yext-types';
import type { LocationsDay } from '../interface/types';
import { getWeekDatesByDay } from './getWeekDatesByDay';

export function getHolidayHoursForWeek(
  holidayHours: YextHolidayHour[] | undefined,
  storeTimezone?: string,
): Partial<Record<LocationsDay, YextHolidayHour>> {
  const result: Partial<Record<LocationsDay, YextHolidayHour>> = {};

  if (!holidayHours || holidayHours.length === 0) {
    return result;
  }

  const weekDates = getWeekDatesByDay(storeTimezone);
  const dayByDate = new Map<string, LocationsDay>();

  for (const [day, date] of Object.entries(weekDates)) {
    dayByDate.set(date.format('YYYY-MM-DD'), day as LocationsDay);
  }

  // Iterate holidays (not days) so that a later duplicate entry for the same
  // date still wins, matching the behavior this replaced.
  for (const holiday of holidayHours) {
    const day = dayByDate.get(holiday.date);

    if (day) {
      result[day] = holiday;
    }
  }

  return result;
}
